<template>
  <Modal v-model="inventoryPriorityConfigModal" :title="$t('key1005774')" width="500"
    :transfer="false" :mask-closable="false" @on-visible-change="inventoryPriorityConfigChange">
    <Form ref="inventoryPriorityConfigForm" :model="inventoryPriorityConfigForm" label-position="top" @submit.native.prevent>
      <Row type="flex" style="width: 90%">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1005775')" class="radio_styles" prop="priority">
            <RadioGroup v-model="inventoryPriorityConfigForm.priority">
              <Radio :label="1">{{ $t('key1005779') }}</Radio>
              <Radio :label="2">{{ $t('key1005777') + configCharacters() + $t('key1005778') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1005776')" class="radio_styles" prop="waitInventory">
            <RadioGroup v-model="inventoryPriorityConfigForm.waitInventory">
              <Radio :label="1">{{ $t('key1005780') }}</Radio>
              <Radio :label="2">{{ $t('key1005781') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="inventoryPriorityConfigModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="inventoryPriorityConfigBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {commonLocalStorage, getDistributorConfigurationItemData} from "@/utils/common";

export default {
  name: 'inventoryPriorityConfigModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      inventoryPriorityConfigModal: false,
      inventoryPriorityConfigForm: {
        priority: 1,
        waitInventory: 1,
      },
      talgKey: 'distributorInventoryPriority'
    }
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  methods: {
    // 初始化数据
    initInventoryPriorityConfigData() {
      const info = commonLocalStorage.getItem('distributorConfigurationItemInfo') ?? this.$store.state.distributorConfigurationItemInfo;
      let obj = info?.distributorInventoryPriority;
      if (obj) {
        for (let key in this.inventoryPriorityConfigForm) {
          this.inventoryPriorityConfigForm[key] = obj[key];
        }
        this.$forceUpdate();
      }
      this.inventoryPriorityConfigModal = true;
    },
    // 保存
    inventoryPriorityConfigBtn() {
      let v = this;
      v.$refs['inventoryPriorityConfigForm'].validate((valid) => {
        if (valid) {
          v.axios.post(api.post_ymsDistributorInventory_setDistributorInventoryPriority, v.inventoryPriorityConfigForm,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.inventoryPriorityConfigModal = false;
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113'));
              getDistributorConfigurationItemData(true);
            }
          });
        }
      });
    },
    // 监听弹窗
    inventoryPriorityConfigChange(val) {
      if (!val) {
        this.$refs['inventoryPriorityConfigForm'].resetFields();
      }
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="less">
.radio_styles {
  .ivu-form-item-label {
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
